import OnboardScheduleInvoices from './OnboardScheduleInvoices';

export default OnboardScheduleInvoices;
